import React from 'react';
import { X, DownloadSimple, ArrowSquareOut } from '@phosphor-icons/react';

/**
 * Integrated PDF viewer modal using <iframe>.
 * @param {string} url - absolute URL to PDF document (or blob URL).
 * @param {string} title - modal title.
 */
export const PdfViewerModal = ({ show, url, title, onClose }) => {
  if (!show || !url) return null;
  return (
    <div
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: '20px' }}
      onClick={onClose}
      data-testid="pdf-viewer-overlay"
    >
      <div
        style={{ backgroundColor: 'white', borderRadius: '6px', width: '100%', maxWidth: '1000px', height: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '12px 18px', borderBottom: '1px solid #E2E2E6', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#F8F9FB' }}>
          <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '700' }}>{title || 'Document PDF'}</h3>
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            <a href={url} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm" title="Ouvrir dans un nouvel onglet" data-testid="pdf-open-external">
              <ArrowSquareOut size={14} />
            </a>
            <a href={url} download className="btn btn-secondary btn-sm" title="Telecharger" data-testid="pdf-download">
              <DownloadSimple size={14} />
            </a>
            <button onClick={onClose} className="btn btn-secondary btn-sm" title="Fermer" data-testid="pdf-close">
              <X size={16} />
            </button>
          </div>
        </div>
        <object
          title={title || 'PDF'}
          data={url}
          type="application/pdf"
          style={{ flex: 1, border: 'none', width: '100%' }}
          data-testid="pdf-viewer-iframe"
        >
          <div style={{ padding: 30, textAlign: 'center', color: '#5E5F66' }}>
            Votre navigateur ne peut pas afficher le PDF directement.
            <br /><br />
            <a href={url} target="_blank" rel="noreferrer" className="btn btn-primary">
              <ArrowSquareOut size={14} /> Ouvrir dans un nouvel onglet
            </a>
          </div>
        </object>
      </div>
    </div>
  );
};
